import LieferscheineLayout from '@/layouts/lieferscheine/LieferscheineLayout.vue';
import listtype from '@/config/eingangsrechnung/listtypes';

export default [
  {
    path: 'lieferscheine',
    component: LieferscheineLayout,
    children: [
      {
        path: '',
        name: 'lieferscheine',
        component: () => import('@/views/lieferscheine/LieferscheineStartseite.vue'),
      },
      {
        path: 'liste/unzugeordnet',
        name: 'lieferscheine.liste.unzugeordnet',
        component: () => import('@/views/lieferscheine/LieferscheinListe.vue'),
        props: {
          type: {
            id: listtype.unzugeordnet,
            title: 'Unzugeordnete Lieferscheine',
          },
        },
      },
      {
        path: 'liste/abteilung/:abteilung',
        name: 'lieferscheine.liste.abteilung',
        component: () => import('@/views/lieferscheine/LieferscheinListe.vue'),
        props: (route) => ({
          type: {
            id: listtype.abteilung,
            value: route.params.abteilung,
          },
        }),
      },
      {
        path: 'liste/freigegeben',
        name: 'lieferscheine.liste.freigegeben',
        component: () => import('@/views/lieferscheine/LieferscheinListe.vue'),
        props: {
          type: {
            id: listtype.freigegeben,
            title: 'Freigegebene Lieferscheine',
            showExport: true,
          },
        },
      },
      {
        path: 'liste/archiv',
        name: 'lieferscheine.liste.archiv',
        component: () => import('@/views/lieferscheine/LieferscheinListe.vue'),
        props: {
          type: {
            id: listtype.archiv,
            title: 'Archivierte Leiferscheine',
          },
        },
      },
      {
        path: 'liste/papierkorb',
        name: 'lieferscheine.liste.papierkorb',
        component: () => import('@/views/lieferscheine/LieferscheinListe.vue'),
        props: {
          type: {
            id: listtype.papierkorb,
            title: 'Papierkorb',
          },
        },
      },
      {
        path: 'liste/abgelehnt',
        name: 'lieferscheine.liste.abgelehnt',
        component: () => import('@/views/lieferscheine/LieferscheinListe.vue'),
        props: {
          type: {
            id: listtype.abgelehnt,
            title: 'Gesperrte Lieferscheine',
          },
        },
      },
      {
        path: 'detail/:id',
        name: 'lieferscheine.detail',
        component: () => import('@/views/lieferscheine/LieferscheinDetail.vue'),
        props: true,
      },
    ],
  },
];
